export default {
  date: 'date',
  number: 'number',
  time: 'time',
}
